import { useCallback, useRef, useState } from 'react'
import { useMount } from 'react-use'
import cookies from 'lib/cookies'

/**
 * Alma B2C CMPV2
 *
 * Documentation about alma cmp consents:
 * https://github.com/almamedia/alma-cmp-consents
 */

const defaultFeatureConsents = {
    googleAnalytics: false,
    googleLogin: false,
    sentry: false,
}

const useAlmaCmp = () => {
    const isConsentSet = useRef(false)
    const [featureConsents, setFeatureConsents] = useState(defaultFeatureConsents)

    const handleAlmaConsentEvent = useCallback((consentData) => {
        window.ALMA.cmpV2.getNonTCFVendorConsents((vendors) => {
            const featureConsents = {}

            if (consentData.detail.standard[1]) {
                if (vendors[3] && consentData.detail.standard[8]) {
                    featureConsents.googleAnalytics = true
                }

                if (vendors[3]) {
                    featureConsents.googleLogin = true
                }

                if (vendors[33]) {
                    featureConsents.sentry = true
                }
            }

            cookies.set('__oma-vendor-consent', JSON.stringify({ standard: consentData.detail.standard, vendors }))

            setFeatureConsents({ ...defaultFeatureConsents, ...featureConsents })
        })

        if (!isConsentSet.current) {
            // We need this for the first time only
            window.removeEventListener(
                'alma_cmp_v2_consents_available_repetitive',
                handleAlmaConsentEvent
            )

            // Set listener to read possible consent changes user might do
            window.addEventListener(
                'alma_cmp_v2_has_optedin',
                handleAlmaConsentEvent,
                false
            )

            isConsentSet.current = true
        }
    }, [setFeatureConsents])

    useMount(() => {
        window.addEventListener('alma_cmp_v2_consents_available_repetitive', handleAlmaConsentEvent, false)

        return () => {
            window.removeEventListener('alma_cmp_v2_consents_available_repetitive', handleAlmaConsentEvent)
            window.removeEventListener('alma_cmp_v2_has_optedin', handleAlmaConsentEvent)
        }
    })

    return { featureConsents }
}

export default useAlmaCmp
